import React, { Fragment, useContext, useEffect, useState } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { connect } from 'react-redux';
import { Badge, Button, Dropdown, Modal, Table } from 'react-bootstrap';
import Editor from '@jsx/components/RichTextEditor';
import { AdminActions } from '@adapters/redux/reducer/admin';
import { ToastNotificationContext } from '@context/ToastNotificationContext';
import Swal from 'sweetalert2';
import PageLoader from '../Loader/PageLoader';
import { BED_TYPES, ICON_MORE, ROOM_FEATURES } from '@services/constant';
import { fullBackendPath, getRoomFeatureClass } from 'core/helpers';

const Page = (props) => {
  const { notifySuccess, notifyError } = useContext(ToastNotificationContext);
  const { rooms, updateData, deleteData, updating } = props;

  const [showModal, setShowModal] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);

  const [modalType, setModalType] = useState('create');
  const [itemUpdate, setItemUpdate] = useState();
  const [name, setName] = useState('');
  const [nameVie, setNameVie] = useState('');
  const [price, setPrice] = useState('');
  const [priceVie, setPriceVie] = useState('');
  const [describe, setDescribe] = useState('');
  const [describeVie, setDescribeVie] = useState('');
  const [shortDescribe, setShortDescribe] = useState('');
  const [shortDescribeVie, setShortDescribeVie] = useState('');
  const [adults, setAdults] = useState('1');
  const [bedType, setBedType] = useState('1');
  const [roomSize, setRoomSize] = useState('');
  const [roomFeatures, setRoomFeatures] = useState([]);
  const [background, setBackground] = useState(null);
  const [roomImage1, setRoomImage1] = useState(null);
  const [roomImage2, setRoomImage2] = useState(null);
  const [roomImage3, setRoomImage3] = useState(null);

  useEffect(() => {
    if (!showModal) {
      setItemUpdate(null);
      setName('');
      setNameVie('');
      setPrice('');
      setPriceVie('');
      setDescribe('');
      setDescribeVie('');
      setShortDescribe('');
      setShortDescribeVie('');
      setAdults('1');
      setBedType('1');
      setRoomSize('');
      setRoomFeatures([]);
      setBackground(null);
      setRoomImage1(null);
      setRoomImage2(null);
      setRoomImage3(null);
    }
  }, [showModal]);

  const onClickShowModalCreate = () => {
    setModalType('create');
    setName('');
    setNameVie('');
    setPrice('');
    setPriceVie('');
    setDescribe('');
    setDescribeVie('');
    setShortDescribe('');
    setShortDescribeVie('');
    setAdults('1');
    setBedType('1');
    setRoomSize('');
    setRoomFeatures([]);
    setBackground(null);
    setRoomImage1(null);
    setRoomImage2(null);
    setRoomImage3(null);
    setShowModal(true);
  };

  const onClickShowModalEdit = (item, isEdit = true) => {
    const {
      adults,
      name,
      name_vi,
      describe,
      describe_vi,
      short_describe,
      short_describe_vi,
      price,
      price_vi,
      bed_type,
      room_size,
      room_feature,
    } = item;

    isEdit && setModalType('edit');
    setItemUpdate(item);
    setName(name);
    setNameVie(name_vi);
    setPrice(price);
    setPriceVie(price_vi);
    setDescribe(describe);
    setDescribeVie(describe_vi);
    setShortDescribe(short_describe);
    setShortDescribeVie(short_describe_vi);
    setBedType(bed_type);
    setRoomSize(room_size);
    setAdults(adults);
    setRoomFeatures(room_feature || []);
    setBackground(null);
    setRoomImage1(null);
    setRoomImage2(null);
    setRoomImage3(null);
    isEdit ? setShowModal(true) : setShowModalDetail(true);
  };

  const onClickDelete = (item) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: 'red',
      position: 'top',
      customClass: 'margin-top-20',
      reverseButtons: true,
    }).then(({ value }) => {
      if (value) {
        deleteData(item.id, `room/${item.id}`, 'rooms', (isError, error) => {
          if (isError) {
            notifyError(error);
          } else {
            notifySuccess('Delete successfully');
          }
        });
      }
    });
  };

  const onSubmit = () => {
    const method = modalType === 'create' ? 'post' : 'put';
    const url = modalType === 'create' ? 'room' : `room/${itemUpdate.id}`;

    const params = {
      adults,
      name,
      name_vi: nameVie,
      describe,
      describe_vi: describeVie,
      short_describe: shortDescribe,
      short_describe_vi: shortDescribeVie,
      room_background: background,
      room_image1: roomImage1,
      room_image2: roomImage2,
      room_image3: roomImage3,
      price,
      price_vi: priceVie,
      room_size: roomSize,
      bed_type: bedType,
      room_features: roomFeatures,
      images: [],
    };

    if (roomImage1)
      params.images.push({
        field: 'room_image1',
        image: roomImage1,
      });

    if (roomImage2)
      params.images.push({
        field: 'room_image2',
        image: roomImage2,
      });

    if (roomImage3)
      params.images.push({
        field: 'room_image3',
        image: roomImage3,
      });

    if (background)
      params.images.push({
        field: 'room_background',
        image: background,
      });

    updateData(method, url, params, 'rooms', (isError, error) => {
      if (isError) {
        notifyError(error);
      } else {
        setShowModal(false);
        notifySuccess(
          method === 'post' ? 'Create successfully' : 'Update successfully'
        );
      }
    });
  };

  const toggleRoomFeature = (id) => {
    if (roomFeatures.includes(id)) {
      const index = roomFeatures.indexOf(id);
      setRoomFeatures(roomFeatures.filter((feature) => feature !== id));
    } else {
      setRoomFeatures([...roomFeatures, id]);
    }
  };

  return (
    <Fragment>
      <div className="text-right mb-3">
        <button onClick={onClickShowModalCreate} className="btn btn-success">
          Create
        </button>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">List Rooms</h4>
            </div>
            <div className="card-body position-relative">
              {updating && !showModal && <PageLoader />}
              <Table responsive>
                <thead>
                  <tr>
                    <th className="width80">
                      <strong>#</strong>
                    </th>
                    <th>
                      <strong>Name</strong>
                    </th>
                    {/* <th>
                      <strong>Short describe</strong>
                    </th> */}
                    {/* <th>
                      <strong>Price</strong>
                    </th> */}
                    <th>
                      <strong>Adults</strong>
                    </th>
                    <th>
                      <strong>Bed type</strong>
                    </th>
                    <th>
                      <strong>Room size</strong>
                    </th>
                    {/* <th>
                      <strong>Features</strong>
                    </th> */}
                    <th className="action-column">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {rooms?.map((item, index) => {
                    const {
                      adults,
                      name,
                      short_describe,
                      describe,
                      price,
                      room_size,
                      bed_type,
                      room_feature,
                    } = item;
                    return (
                      <tr key={index}>
                        <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {index + 1}
                        </td>
                        <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {name}
                        </td>
                        {/* <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {short_describe}
                        </td> */}
                        {/* <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {price}
                        </td> */}
                        <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {adults}
                        </td>
                        <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {bed_type}
                        </td>
                        <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {room_size}
                        </td>
                        {/* <td
                          className="cursor-pointer"
                          onClick={() => onClickShowModalEdit(item, false)}
                        >
                          {room_feature.map((feature) => {
                            return (
                              <i
                                key={`feature-${feature}`}
                                style={{ fontSize: 16, marginRight: 10 }}
                                className={getRoomFeatureClass(feature)}
                                title={ROOM_FEATURES[feature]}
                              ></i>
                            );
                          })}
                        </td> */}
                        <td className="action-column">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              className="light sharp i-false"
                            >
                              {ICON_MORE}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => onClickShowModalEdit(item)}
                              >
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => onClickDelete(item)}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
      <Modal className="fade" enforceFocus={false} show={showModal} size="lg">
        <Modal.Header>
          <Modal.Title>
            {modalType === 'create' ? 'Create' : 'Edit'}
          </Modal.Title>
          <Button
            variant=""
            className="btn-close"
            disabled={updating}
            onClick={() => setShowModal(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          {updating && <PageLoader />}
          <div className="form-group">
            <label className="form-label">Name (ENG)</label>
            <input
              className="form-control"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Name (VIE)</label>
            <input
              className="form-control"
              type="text"
              value={nameVie}
              onChange={(e) => setNameVie(e.target.value)}
            />
          </div>
          {/* <div className="form-group mt-3">
            <label className="form-label">Price</label>
            <input
              className="form-control"
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div> */}
          {/* <div className="form-group mt-3">
            <label className="form-label">Short describe (ENG)</label>
            <input
              className="form-control"
              type="text"
              value={shortDescribe}
              onChange={(e) => setShortDescribe(e.target.value)}
            />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Short describe (VIE)</label>
            <input
              className="form-control"
              type="text"
              value={shortDescribeVie}
              onChange={(e) => setShortDescribeVie(e.target.value)}
            />
          </div> */}
          <div className="form-group mt-3">
            <label className="form-label">Describe (ENG)</label>
            <Editor value={describe} onChange={setDescribe} />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Describe (VIE)</label>
            <Editor value={describeVie} onChange={setDescribeVie} />
          </div>
          {/* <div className="form-group mt-3">
            <label className="form-label">Adults</label>
            <input
              className="form-control"
              type="number"
              value={adults}
              onChange={(e) => setAdults(e.target.value)}
            />
          </div> */}
          {/* <div className="form-group mt-3">
            <label className="form-label">Bed type</label>
            <select
              value={bedType}
              className="form-control"
              onChange={(e) => setBedType(e.target.value)}
            >
              {Object.keys(BED_TYPES).map((type) => {
                return (
                  <option key={type} value={type} selected={bedType === type}>
                    {BED_TYPES[type]}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Room size (m²)</label>
            <input
              className="form-control"
              type="number"
              onChange={(e) => setRoomSize(e.target.value)}
            />
          </div> */}
          {/* <div className="form-group mt-3">
            <label className="form-label">Room Features</label>
            <div className="row">
              <div className="col-xl-4 col-xxl-6 col-6">
                <div className="form-check custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={roomFeatures.includes(1)}
                    onChange={() => toggleRoomFeature(1)}
                  />
                  <label className="form-check-label" htmlFor="tv">
                    TV
                  </label>
                </div>
              </div>
              <div className="col-xl-4 col-xxl-6 col-6">
                <div className="form-check custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={roomFeatures.includes(2)}
                    onChange={() => toggleRoomFeature(2)}
                  />
                  <label className="form-check-label" htmlFor="free-wifi">
                    Free Wifi
                  </label>
                </div>
              </div>
              <div className="col-xl-4 col-xxl-6 col-6">
                <div className="form-check custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={roomFeatures.includes(3)}
                    onChange={() => toggleRoomFeature(3)}
                  />
                  <label className="form-check-label" htmlFor="air-condition">
                    Air Condition
                  </label>
                </div>
              </div>
              <div className="col-xl-4 col-xxl-6 col-6">
                <div className="form-check custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={roomFeatures.includes(4)}
                    onChange={() => toggleRoomFeature(4)}
                  />
                  <label className="form-check-label" htmlFor="heater">
                    Heater
                  </label>
                </div>
              </div>
              <div className="col-xl-4 col-xxl-6 col-6">
                <div className="form-check custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={roomFeatures.includes(5)}
                    onChange={() => toggleRoomFeature(5)}
                  />
                  <label className="form-check-label" htmlFor="phone">
                    Phone
                  </label>
                </div>
              </div>
              <div className="col-xl-4 col-xxl-6 col-6">
                <div className="form-check custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={roomFeatures.includes(6)}
                    onChange={() => toggleRoomFeature(6)}
                  />
                  <label className="form-check-label" htmlFor="laundry">
                    Laundry
                  </label>
                </div>
              </div>
            </div>
          </div> */}
          <div className="row">
            <div className="form-group col-md-6 mt-3">
              <label className="form-label">Background image</label>
              <input
                className="form-control"
                type="file"
                accept="image/png, image/jpeg"
                onChange={(e) => setBackground(e.target.files[0])}
              />
            </div>
            <div className="form-group col-md-6 mt-3">
              <label className="form-label">Image 1</label>
              <input
                className="form-control"
                type="file"
                accept="image/png, image/jpeg"
                onChange={(e) => setRoomImage1(e.target.files[0])}
              />
            </div>
            <div className="form-group col-md-6 mt-3">
              <label className="form-label">Image 2</label>
              <input
                className="form-control"
                type="file"
                accept="image/png, image/jpeg"
                onChange={(e) => setRoomImage2(e.target.files[0])}
              />
            </div>
            <div className="form-group col-md-6 mt-3">
              <label className="form-label">Image 3</label>
              <input
                className="form-control"
                type="file"
                accept="image/png, image/jpeg"
                onChange={(e) => setRoomImage3(e.target.files[0])}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={updating}
            variant="danger light"
            onClick={() => setShowModal(false)}
          >
            Close
          </Button>
          <Button
            disabled={updating}
            variant=""
            onClick={onSubmit}
            className="btn btn-primary"
          >
            {modalType === 'edit' ? 'Update' : 'Create'}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        className="fade"
        enforceFocus={false}
        show={showModalDetail}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Detail</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setShowModalDetail(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label className="form-label">Name (ENG)</label>
            <input className="form-control" type="text" value={name} disabled />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Name (VIE)</label>
            <input className="form-control" type="text" value={nameVie} disabled />
          </div>
          {/* <div className="form-group mt-3">
            <label className="form-label">Price</label>
            <input
              className="form-control"
              type="number"
              value={price}
              disabled
            />
          </div> */}
          {/* <div className="form-group mt-3">
            <label className="form-label">Short describe (ENG)</label>
            <textarea
              className="form-control"
              type="text"
              value={shortDescribe}
              style={{ resize: 'none' }}
              disabled
            />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Short describe (VIE)</label>
            <textarea
              className="form-control"
              type="text"
              value={shortDescribeVie}
              style={{ resize: 'none' }}
              disabled
            />
          </div> */}
          <div className="form-group mt-3">
            <label className="form-label">Describe (ENG)</label>
            <Editor value={describe} disabled={true} />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Describe (VIE)</label>
            <Editor value={describeVie} disabled={true} />
          </div>
          {/* <div className="form-group mt-3">
            <label className="form-label">Adults</label>
            <input
              className="form-control"
              type="number"
              value={adults}
              onChange={(e) => setAdults(e.target.value)}
              disabled
            />
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Bed type</label>
            <select value={bedType} className="form-control" disabled>
              <option value="1" selected={bedType === '1'}>
                Single Bed
              </option>
              <option value="2" selected={bedType === '2'}>
                Double Bed
              </option>
              <option value="3" selected={bedType === '3'}>
                Queen Size Bed
              </option>
              <option value="4" selected={bedType === '4'}>
                King Size Bed
              </option>
              <option value="5" selected={bedType === '5'}>
                Super King Size Bed
              </option>
            </select>
          </div>
          <div className="form-group mt-3">
            <label className="form-label">Room size (m²)</label>
            <input className="form-control" type="number" disabled />
          </div> */}
          {/* <div className="form-group mt-3">
            <label className="form-label">Room Features</label>
            <div className="row">
              <div className="col-xl-4 col-xxl-6 col-6">
                <div className="form-check custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={roomFeatures.includes(1)}
                    disabled
                  />
                  <label className="form-check-label" htmlFor="tv">
                    TV
                  </label>
                </div>
              </div>
              <div className="col-xl-4 col-xxl-6 col-6">
                <div className="form-check custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={roomFeatures.includes(2)}
                    disabled
                  />
                  <label className="form-check-label" htmlFor="free-wifi">
                    Free Wifi
                  </label>
                </div>
              </div>
              <div className="col-xl-4 col-xxl-6 col-6">
                <div className="form-check custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={roomFeatures.includes(3)}
                    disabled
                  />
                  <label className="form-check-label" htmlFor="air-condition">
                    Air Condition
                  </label>
                </div>
              </div>
              <div className="col-xl-4 col-xxl-6 col-6">
                <div className="form-check custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={roomFeatures.includes(4)}
                    disabled
                  />
                  <label className="form-check-label" htmlFor="heater">
                    Heater
                  </label>
                </div>
              </div>
              <div className="col-xl-4 col-xxl-6 col-6">
                <div className="form-check custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={roomFeatures.includes(5)}
                    disabled
                  />
                  <label className="form-check-label" htmlFor="phone">
                    Phone
                  </label>
                </div>
              </div>
              <div className="col-xl-4 col-xxl-6 col-6">
                <div className="form-check custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={roomFeatures.includes(6)}
                    disabled
                  />
                  <label className="form-check-label" htmlFor="laundry">
                    Laundry
                  </label>
                </div>
              </div>
            </div>
          </div> */}
          <div className="row">
            <div className="form-group col-md-6 mt-3">
              <label className="form-label">Background image</label>
              {itemUpdate?.room_background?.path && (
                <img
                  className="img-responsive"
                  width={'100%'}
                  src={fullBackendPath(itemUpdate?.room_background?.path)}
                />
              )}
            </div>
            <div className="form-group col-md-6 mt-3">
              <label className="form-label">Image 1</label>
              {itemUpdate?.room_image1?.path && (
                <img
                  className="img-responsive"
                  width={'100%'}
                  src={fullBackendPath(itemUpdate?.room_image1?.path)}
                />
              )}
            </div>
            <div className="form-group col-md-6 mt-3">
              <label className="form-label">Image 2</label>
              {itemUpdate?.room_image2?.path && (
                <img
                  className="img-responsive"
                  width={'100%'}
                  src={fullBackendPath(itemUpdate?.room_image2?.path)}
                />
              )}
            </div>
            <div className="form-group col-md-6 mt-3">
              <label className="form-label">Image 3</label>
              {itemUpdate?.room_image3?.path && (
                <img
                  className="img-responsive"
                  width={'100%'}
                  src={fullBackendPath(itemUpdate?.room_image3?.path)}
                />
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={updating}
            variant="danger light"
            onClick={() => setShowModalDetail(false)}
          >
            Close
          </Button>
          <Button
            disabled={updating}
            variant=""
            onClick={() => {
              setShowModalDetail(false);
              onClickShowModalEdit(itemUpdate);
            }}
            className="btn btn-primary"
          >
            Edit
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  rooms: state.admin.rooms,
  updating: state.admin.updating,
});

const mapDispatchToProps = (dispatch) => ({
  updateData: (method, url, params, field, callback) =>
    dispatch(AdminActions.updateData(method, url, params, field, callback)),
  deleteData: (id, url, field, callback) =>
    dispatch(AdminActions.deleteData(id, url, field, callback)),
});

const withErrorBoundary = (props) => (
  <ErrorBoundary>
    <Page {...props} />
  </ErrorBoundary>
);

export default connect(mapStateToProps, mapDispatchToProps)(withErrorBoundary);
